import { createClientApi } from '@alfa-bank/newclick-core/api';
import { confirmClaim } from './confirm-claim';
import { confirmOwner } from './confirm-owner';
import { createClaim } from './create-claim';
import { deleteClaim } from './delete-claim';
import { getClaimStatus } from './get-claim-status';
import { getClaimUpdatability } from './get-claim-updatability';
import { getClaimUpdatabilityAkey } from './get-claim-updatability-akey';
import { getDuplicates } from './get-duplicates';
import { getPhoneInformation } from './information';
import { intentClaim } from './intent-claim';
import { sendOwnerOTP } from './send-owner-otp';
/**
 * http://git.moscow.alfaintra.net/projects/AM/repos/api-phone/browse
 */
export const phoneApiDeclaration = {
    intentClaim,
    createClaim,
    confirmClaim,
    sendOwnerOTP,
    confirmOwner,
    getClaimStatus,
    getClaimUpdatability,
    getClaimUpdatabilityAkey,
    getDuplicates,
    deleteClaim,
    getPhoneInformation,
};
export const phoneApi = createClientApi(phoneApiDeclaration, 'v1/phone');
